var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4027 11.1271C10.421 11.1271 9.94899 11.6744 8.33789 11.6744C6.7268 11.6744 6.25818 11.1271 5.27305 11.1271C2.73497 11.1271 0.675781 13.1863 0.675781 15.7244V16.6C0.675781 17.5065 1.41121 18.2419 2.31766 18.2419H14.3581C15.2646 18.2419 16 17.5065 16 16.6V15.7244C16 13.1863 13.9408 11.1271 11.4027 11.1271ZM14.3581 16.6H2.31766V15.7244C2.31766 14.0962 3.64485 12.769 5.27305 12.769C5.77245 12.769 6.58313 13.3163 8.33789 13.3163C10.1063 13.3163 10.8999 12.769 11.4027 12.769C13.0309 12.769 14.3581 14.0962 14.3581 15.7244V16.6ZM8.33789 10.5798C11.0573 10.5798 13.2635 8.37352 13.2635 5.65416C13.2635 2.93479 11.0573 0.728516 8.33789 0.728516C5.61853 0.728516 3.41225 2.93479 3.41225 5.65416C3.41225 8.37352 5.61853 10.5798 8.33789 10.5798ZM8.33789 2.3704C10.1474 2.3704 11.6217 3.84467 11.6217 5.65416C11.6217 7.46365 10.1474 8.93792 8.33789 8.93792C6.5284 8.93792 5.05413 7.46365 5.05413 5.65416C5.05413 3.84467 6.5284 2.3704 8.33789 2.3704Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0c26f50fb582ab5da1705a81f2674229.svg";
export { ForwardRef as ReactComponent };